import { render, staticRenderFns } from "./endpage.vue?vue&type=template&id=173647c9&scoped=true&"
import script from "./endpage.vue?vue&type=script&lang=js&"
export * from "./endpage.vue?vue&type=script&lang=js&"
import style0 from "./endpage.vue?vue&type=style&index=0&id=173647c9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "173647c9",
  null
  
)

export default component.exports